
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/listing/create",
      function () {
        return require("private-next-pages/listing/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/listing/create"])
      });
    }
  